import angular from 'angular';

function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('sim-logs', {
    url: '/sim-logs',
    templateProvider: () =>
      import(/* webpackChunkName: "sim-logs" */ './sim-logs.pug').then(
        ({ default: tpl }) => tpl,
      ),
    controller: 'simLogsCtrl as vm',
    requiredPermission: 'sim-logs',
    resolve: {
      loadCtrl: $ocLazyLoad =>
        Promise.all([
          import(/* webpackChunkName: "sim" */ './sim-logs.controller'),
          import('../../extensions/init/ag-grid'),
          import('../../extensions/directives/select2'),
          import('../../extensions/directives/date-range-picker'),
          import('../../extensions/directives/rome'),
          import('../../extensions/directives/validator-date'),
        ]).then(([module]) => {
          $ocLazyLoad.load({ name: module.name });
          return module.controller;
        }),
    },
  });
}

export default angular.module('app.sim-logs.routing', []).config(routes);
